// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__MXh8p","teamList":"styles_teamList__2nUGm"};